import {
    type FC
} from "react";
import type IPaginationNextProps from "./type";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import {
    usePaginationContext
} from "../../context";
import {
    PaginationNextIcon
} from "../../icons";
import PaginationControl from "../control";

const PaginationNext: FC<IPaginationNextProps> = ({
    customTheme: customThemeProp,
    isDisabled: isDisabledProp,
    onPress,
    style,
    title
}) => {
    const context = usePaginationContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    const isIconOnly = context.stepTitleBehaviour === "hidden" || (context.stepTitleBehaviour === "auto" && (context.variant === "compact" || context.isCompact));

    const isLastPage = context.pageCount === undefined ? context.hasNextPage === false : context.page >= context.pageCount;

    const nextPage = context.page + 1;

    const handlePress = () => {
        if(onPress) {
            onPress();

            return;
        }

        context.onPageChange(nextPage);
    };

    return <PaginationControl
        href={isLastPage ? undefined : context.hrefExtractor?.(nextPage)}
        aria-label={title ?? localize("pagination-next-page")}
        customTheme={customThemeProp ?? context.customTheme}
        isAriaDisabled={isDisabledProp ?? isLastPage}
        title={title ?? localize("pagination-next")}
        isDisabled={context.isDisabled}
        icon={PaginationNextIcon}
        isIconOnly={isIconOnly}
        onPress={handlePress}
        size={context.size}
        iconDirection="end"
        style={style}
        kind="step"
    />;
};
export default PaginationNext;
